import { createFileRoute, Outlet } from '@tanstack/react-router'
import { protectedRouteGuard } from '@/utils/routeGuards'

export const Route = createFileRoute('/infra/network')({
  loader: () => ({
    crumb: 'Network',
  }),
  beforeLoad: protectedRouteGuard,
  component: () => <Outlet />,
})